import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckoutPaymentMethodsComponentDef } from '@df/checkout/checkout-payment-methods.component.def';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { Adyen } from '@df/module-adyen/adyen.namespace';
import { ApplePayFilterPipe } from '@df/module-apple-pay/apple-pay-filter.pipe';
import { ApplePayService } from '@df/module-apple-pay/apple-pay.service';
import { NBarclaycardApplePay } from '@df/module-barclaycard/apple-pay/barclaycard-apple-pay.namespace';
import { NBarclaycardCybersource } from '@df/module-barclaycard/barclaycard-cybersource.namespace';
import { NBarclaycardGooglePay } from '@df/module-barclaycard/google-pay/barclaycard-google-pay.namespace';
import { CreditCard } from '@df/session/api/credit-cards/credit-card';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import difference from 'lodash-es/difference';
import findIndex from 'lodash-es/findIndex';
import { AdyenSecuredFieldsComponent } from '../../module/adyen/card/secured-fields/adyen-secured-fields.component';
import { BarclaycardFlexMicroformComponent } from '../../module/barclaycard-cybersource/flex-microform/barclaycard-flex-microform.component';
import { V12RetailFinanceComponent } from '../../module/v12-retail-finance/v12-retail-finance.component';
import { PaymentIconComponent, TPaymentIcon } from '../../ui/display/payment-icon/payment-icon.component';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { Radio2Component } from '../../ui/form/radio2/radio2.component';
import { CheckoutVaultCardComponent } from '../vault-card/checkout-vault-card.component';
import { CheckoutFormComponent } from './../form/checkout-form.component';
import { CheckoutStepComponent } from './../step/checkout-step.component';
@Component({
    selector: 'checkout-payment-methods',
    templateUrl: './checkout-payment-methods.html',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        InputWrapComponent,
        CheckoutVaultCardComponent,
        BarclaycardFlexMicroformComponent,
        V12RetailFinanceComponent,
        AdyenSecuredFieldsComponent,
        PaymentIconComponent,
        Radio2Component,
        ApplePayFilterPipe,
        TranslationModule,
        RadioGroupDirective,
        InputWrapBodyDirective
    ]
})
export class CheckoutPaymentMethodsComponent extends CheckoutPaymentMethodsComponentDef implements OnInit {
    /**
     * Class constructor
     */
    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        checkoutStepComponent: CheckoutStepComponent,
        changeDetectorRef: ChangeDetectorRef,
        private applePayService: ApplePayService
    ) {
        super(checkoutFormComponent, checkoutStepComponent, changeDetectorRef);
    }
    getLogos(method: Checkout.IPaymentMethod): TPaymentIcon[] | undefined {
        switch (method.code) {
            case 'paypal_express':
                return ['paypal'];
            case NBarclaycardCybersource.EPaymentMethod.chcybersource:
                return ['visa', 'mc', 'amex'];
            case Adyen.PaymentMethod.GooglePay:
                return ['googlepay'];
            case NBarclaycardGooglePay.methodCode:
                return ['googlepay'];
            case Adyen.PaymentMethod.ApplePay:
                return ['apple'];
            case NBarclaycardApplePay.methodCode:
                return ['apple'];
        }
    }
    protected getMethods(): Checkout.IPaymentMethod[] {
        const superMethods = super.getMethods();
        const cards = superMethods.filter(i => (i as CreditCard).isCard);
        const methods = difference(superMethods, cards);
        const adyenIndex = findIndex(methods, i => i.code === Adyen.PaymentMethod.CreditCard);
        if (adyenIndex > -1) {
            methods.splice(adyenIndex + 1, 0, ...cards);
            return methods;
        }
        return superMethods;
    }
    protected validateSelectedMethod(): void {
        super.validateSelectedMethod();
        if (
            [Adyen.PaymentMethod.ApplePay, NBarclaycardApplePay.methodCode].indexOf(<string>this.data?.method) !== -1 &&
            !this.applePayService.isAvailable
        ) {
            this.data.method = undefined;
        }
    }

    methodAsCard(method: Checkout.IPaymentMethod): CreditCard {
        return method as CreditCard;
    }
    asString(i: number | string): string {
        return i as string
    }
}
